export enum BlogType {
  ADVERTISER = 'advertiser',
  CITY = 'city',
  COUNTRY = 'country',
  LANDING = 'landing',
  PRESS = 'press',
  TENANT = 'tenant',
}
